import React, { useState, useEffect } from 'react';
import ExploreAllCard from "./Explorecard";
import { Men_Shirts, Men_Trousers } from "../data/products";
import ModalImage from "./ModalImage";

// Utility to get unique items by ID
const getUniqueById = (arr) => [
  ...new Map(arr.map((item) => [item.id, item])).values(),
];

const MenSelect = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleOpenModal = (id, allItems) => {
    const filtered = allItems.filter((item) => item.id === id);
    setSelectedImages(filtered);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <div className="content">
      <h2 className="Explore-h2">Men Collections</h2>

      <section className="categories section-offwhite">
        <div className="categories__list">
          {getUniqueById(Men_Shirts).map((ExploreAll) => (
            <ExploreAllCard
              key={`men-shirts-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Men_Shirts}
              onImageClick={handleOpenModal}
            />
          ))}

          {getUniqueById(Men_Trousers).map((ExploreAll) => (
            <ExploreAllCard
              key={`men-trousers-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Men_Trousers}
              onImageClick={handleOpenModal}
            />
          ))}
        </div>
      </section>

      {isModalOpen && (
        <ModalImage
          images={selectedImages}
          handleCloseModal={handleCloseModal}
        />
      )}
      {/* { <section className="categories section-offwhite"> }
      {/* <h2>Men Trousers</h2> */}
      {/* <div className="categories__list">
        {Men_Trousers.map(ExploreAll => (
         <ExploreAllCard key={ExploreAll.id} ExploreAll={ExploreAll} />
        ))}
      </div> */}
      {/* </section> */}
    </div>
  );
};

export default MenSelect;
